import { makeAutoObservable } from "mobx";

class SearchModel {
  searchQuery = {
    value: "",
    type: "hotel",
    bookingId: "",
  };
  focusedInput = null;
  startDate = null;
  endDate = null;
  couponCode = "";

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }
}

const SearchStore = new SearchModel();
export default SearchStore;
